// eslint-disable-next-line no-unused-vars
// import { createI18n } from 'vue-i18n';

import Arabic from "./translations/Arabic.js";
import English from "./translations/English.js";
const localization = {
  ar: Arabic,
  en: English,
};
export default localization;
